//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    baseSku: { type: String, required: true },
    skuPrefix: { type: String, required: true }
  },
  data: () => ({
    productGroups: [
      ['classics3', 'sierras', 'renegades'],
      ['vulcans-ff', 'airas-zf', 'velans-tf'],
      ['snipers', 'vanguards']
    ]
  }),
  computed: {
    products () {
      let products = []
      const nonMatchedGroups = []
      this.productGroups.forEach((group) => {
        if (group.includes(this.baseSku)) products = [...group.filter(sku => sku !== this.skuPrefix)]
        else nonMatchedGroups.push(group)
      })
      return [...products, ...nonMatchedGroups].flat()
    }
  }
}
